import React, {useState} from 'react';
import { FormControl, FormLabel, Select, Flex } from '@chakra-ui/react';
import {CloseIcon, EditIcon} from '@chakra-ui/icons';

interface EditableSelectProps {
  label: string;
  value: string;
  // This will tell if the page is create or edit
  isEditing: boolean;
  options: string[];
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const EditableSelect:React.FC<EditableSelectProps> = ({ 
  label, 
  isEditing, 
  value, 
  onChange, 
  options 
}) => {
  const [isEditMode,setIsEditMode]=useState(false);
  return (
    <FormControl mb={2}>
      {/* If not in the editing page that is create page then normal options */}
      {!isEditing && (
        <>
          <Flex justifyContent="space-between" alignItems="center">
            <FormLabel>{label}</FormLabel>
            {isEditing && <EditIcon onClick={() => {setIsEditMode(!isEditMode)}} />}
          </Flex>
          <Select value={value} onChange={onChange}>
            <option disabled selected hidden>
              {''}
            </option>
            {options.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </Select>
        </>
      )}
      {/* If in the editing page and in the edit mode */}
      {isEditing && isEditMode && (
        <>
          <Flex justifyContent="space-between" alignItems="center">
            <FormLabel>{label}</FormLabel>
            {isEditing && <CloseIcon onClick={() => {setIsEditMode(!isEditMode)}} />}
          </Flex>
          <Select value={value} onChange={onChange}>
            <option disabled selected hidden>
              {''}
            </option>
            {options.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </Select>
        </>
      )}
      {/* If in the editing page and not in the edit mode */}
      {isEditing && !isEditMode && (
        <>
          <Flex justifyContent="space-between" alignItems="center">
            <FormLabel>{label}</FormLabel>
            {isEditing && <EditIcon onClick={() => {setIsEditMode(!isEditMode)}} />}
          </Flex>
          <Select disabled={true} value={value} onChange={onChange}>
            <option disabled selected hidden>
              {''}
            </option>
            {options.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </Select>
        </>
      )}
    </FormControl>
  );
};

export default EditableSelect;
